import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import { TopicLoadingCard } from './TopicLoadingCard';
import Topics from './Topics';
import { LANE } from '../constants/displayAs';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';
import useTopicsSuggestedTopics from '../hooks/useTopicsSuggestedTopics';

const TopicsSuggestedTopics = ({ displayAs = LANE }) => {
  const {
    name,
    topics,
    totalTopics,
    isFetchingTopics,
    params,
    loadNextPage,
    handleFetchTopics,
    updateTopicApproval,
  } = useTopicsSuggestedTopics();
  const { setHandleFetchSuggestedTopics, setSuggestedTopicsView } =
    useTopicsIndexContext();

  useEffect(() => {
    if (handleFetchTopics && setHandleFetchSuggestedTopics) {
      setHandleFetchSuggestedTopics(() => handleFetchTopics);
    }
  }, [handleFetchTopics, setHandleFetchSuggestedTopics]);

  return (
    <Box display="block">
      <Topics
        dataTestId="topics-suggested-topics"
        name={name}
        topics={topics}
        totalTopics={totalTopics}
        isFetchingTopics={isFetchingTopics}
        displayAs={displayAs}
        loadNextPage={loadNextPage}
        params={params}
        onSeeAll={setSuggestedTopicsView}
        LoadingItemComponent={TopicLoadingCard}
        updateTopicApproval={updateTopicApproval}
      />
    </Box>
  );
};

TopicsSuggestedTopics.protoTypes = {
  displayAs: PropTypes.string,
};

export default TopicsSuggestedTopics;
